import React, {Component} from 'react';
import PrintPreview from '../PrintPreview';
import PdfStore from 'stores/PdfStore';
import WorkdocStore from 'stores/WorkdocStore'
import './Print.css'
// const Barcode = require('react-barcode');
var NotificationSystem = require('react-notification-system');
class PrintNDMFixingListOnCarDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false, data:{work_no:'',car:{car_registration_no:''},insurer:{claim_no:''},
    receiving:{entrance_date:'',appointment_date:''},
    wagelist:[],partlist:[]}}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){    
    this.loadFixingListOnCarDoc()
  }

  loadFixingListOnCarDoc() {
    let {workNo} = this.props
    
    this.setState({ loading: true })
    PdfStore.loadFixingListOnCarDoc(workNo,'fixoncar_doc',(result) =>{
      let data = result.data
      this.setState({data:data})
      
    })  
  }

  onPrintDoc(){
    let {workNo} = this.props
    WorkdocStore.updateCreateJobStatus(workNo,1,(result)=>{
      this.refs.notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'อับเดทออกใบคุมรายการซ่อมเรียบร้อย ' + workNo + ' ',
        level: 'info',
        position: 'tc'
      });
    },(error)=>{

    })
  }

  renderLogoUrl(logoUrl){
    if(logoUrl===undefined){
      return ('')
    }
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} style={{maxWidth:'100px'}}/>)
  }

  renderInsurerName(insurer){
    let name = insurer.insurer_id*1!==0?insurer.insurer_name:"เงินสด"
    name = (name+"").replace("บริษัท", "");
    name = name.replace("จำกัด", "");
    name = name.replace("(มหาชน)", "");
    name = name.replace("มหาชน", "");
    return (<span>{name}</span>)
  }

  renderWageListData(list){
    return new Array(20).fill('').map((item,index)=>(
      <tr key={index} className="font-20">
        <td className='text-center' style={{width:'5%'}}>{index+1}</td>
        <td style={{width:'45%'}} className=''>{(index<list.length)?list[index].detail:""}</td>
      </tr>
    ))
  }

  renderPartListData(list){
    return new Array(20).fill('').map((item,index)=>(
      <tr key={index} className="font-20">
        <td style={{width:'45%'}} className=''>{(index<list.length)?list[index].detail:""}</td>
        <td className='text-center' style={{width:'5%'}}>*****</td>
      </tr>
    ))
  }

  renderHeader() {
    let {data} = this.state
    return(
      <div>
        <header>
          <h2 className="text-right">{'ใบคุมรายการซ่อม'}</h2>
        </header>
        <article className={'article-company'}>
          <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
            {this.renderLogoUrl(data.logo_url)}
          </div>
          <section className="font-18" style={{width:'85%',paddingTop:'0'}}>
            <strong>
              <p style={{lineHeight:'0.7'}}>{data.company_name} (สำนักงานใหญ่)</p>
              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
              <p style={{lineHeight:'0.7'}}>โทร {data.company_tel} โทรสาร {data.company_fax}</p>             
            </strong>
          </section>
          <section className='text-left' style={{float:'right',width:'15%'}}>
            <table className='table table-ndm-fixing'>
                <tbody>
                    <tr>
                        <td>เลขที่ Job อู่ : </td>
                        <td>-</td>
                    </tr>
                    <tr>
                        <td>เวลา : </td>
                        <td>-</td>
                    </tr>
                </tbody>
            </table>
          </section>
        </article>
      </div>
    )  
  }    

  renderComponentPage() {
    let {work_no,insurer,car,receiving,wagelist,partlist} = this.state.data
    if(wagelist.length>20 || partlist.length>0){
      let noOfPageWage = Math.floor(wagelist.length/20)+1
      let noOfPagePart = Math.floor(partlist.length/20)+1
      let noOfPage = (noOfPagePart>noOfPageWage)?noOfPagePart:noOfPageWage

      let pagelist = []
      for(let i=0;i<noOfPage;i++){
        let begin = wagelist.length>0?wagelist.slice(0, 20):[]
        let beginPart = partlist.length>0?partlist.slice(0, 20):[]
        if(wagelist.length>20){
          wagelist = wagelist.slice(20)
        }else{
          wagelist = wagelist.slice(begin.length)
        }
        if(partlist.length>20){
          partlist = partlist.slice(20)
        }else{
          partlist = partlist.slice(beginPart.length)
        }
        pagelist.push({wagelist:begin,partlist:beginPart})        
      }
      return pagelist.map((item,index)=>(
        <div className='font-print' key={index}>
            <div>
                {this.renderHeader('ต้นฉบับ')}
            </div>
            {this.renderComponentSinglePage(item.wagelist,item.partlist,index,noOfPageWage,noOfPagePart)}
        </div>
      ))
    }else{
      return (
        <div className='font-print'>
            <div>
                {this.renderHeader('ต้นฉบับ')}
            </div>
            {this.renderComponentSinglePage(wagelist,partlist)}
        </div>
      )
    }
  }

  renderComponentSinglePage(wagelist,partlist,index=0,noOfPageWage=1,noOfPagePart=1) {
    let {work_no,insurer,car,receiving} = this.state.data
    return(
      <div key={index}>
        <div>
          <table className='table table-ndm-fixing'>
            <tbody>
              <tr>
                <td style={{width:'20px'}}>ชื่อ</td>
                <td style={{width:'100px'}} className='hr2-b text-center'>บริษัท {this.renderInsurerName(insurer)}</td>
                <td style={{width:'20px'}}>รถเข้า</td>
                <td style={{width:'80px'}} className='hr2-b text-center'>{this.getDate(receiving.entrance_date)}</td>
                <td style={{width:'30px'}}>เลขตัวถัง</td>
                <td style={{width:'80px'}} className='hr2-b text-center'>{car.chassis_no}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <table className='table table-ndm-fixing'>
            <tbody>
              <tr>
                <td style={{width:'40px'}}>รถยี่ห้อ</td>
                <td style={{width:'100px'}} className='hr2-b text-center'>{car.brand}</td>
                <td style={{width:'40px'}}>ทะเบียน</td>
                <td style={{width:'100px'}} className='hr2-b text-center'>{car.car_registration_no}</td>
                <td style={{width:'20px'}}>รุ่น</td>
                <td style={{width:'100px'}} className='hr2-b text-center'>{car.brand+'/'+car.model}</td>
                <td style={{width:'20px'}}>สี</td>
                <td style={{width:'80px'}}className='hr2-b text-center'>{car.car_color}</td>
              </tr>
            </tbody>
          </table>
        </div>  
        <br />  
        <div style={{borderTop:'1px solid #111'}}>
          <div style={{display:'flex'}}>
              <div style={{width:'50%', borderRight:'1px solid #111'}}>
                <table className='table table-ndm-fixing' style={{marginTop:'0'}}>
                    <tbody>
                        <tr>
                            <td className="hr2-b text-center">ลำดับ</td>
                            <td className="hr2-b text-center color-work-cover-file-doc">รายการซ่อม</td>
                        </tr>  
                        <tr>
                            <td className="text-left">เคลมที่</td>
                            <td className="text-left">{insurer.claim_no}</td>
                        </tr>    
                        {this.renderWageListData(wagelist)}                 
                    </tbody>
                </table> 
              </div>
              <div style={{width:'50%', borderLeft:'1px solid #111'}}>
                <table className='table table-ndm-fixing' style={{marginTop:'0'}}>
                    <tbody>
                        <tr>
                            <td className="hr2-b text-center color-pink">รายการเปลี่ยนอะไหล่</td>
                            <td className="hr2-b text-center">จำนวน</td>
                        </tr>  
                        <tr>
                            <td colSpan={2} className="text-left"><br /></td>
                        </tr>   
                        {this.renderPartListData(partlist)}
                    </tbody>
                </table>
              </div>  
          </div>
          <div style={{borderTop:'2px solid #111',borderBottom:'2px solid #111'}}>
            <div style={{display:'flex'}}>
              <div style={{width:'50%', borderRight:'1px solid #111'}}>
                <table className='table table-ndm-fixing' style={{marginTop:'0'}}>
                    <tbody>
                        <tr>
                            <td className="hr2-b text-left">ถ่ายรูปก่อนซ่อม</td>
                            <td className="hr2-b text-center"></td>
                        </tr> 
                        <tr>
                            <td className="hr2-b text-left">ถ่ายรูปสีพื้น</td>
                            <td className="hr2-b text-center"></td>
                        </tr> 
                        <tr>
                            <td className="hr2-b text-left">ถ่ายรูประหว่างซ่อม</td>
                            <td className="hr2-b text-center"></td>
                        </tr> 
                        <tr>
                            <td className="hr2-b text-left">ถ่ายรูปหลังการซ่อม</td>
                            <td className="hr2-b text-center"></td>
                        </tr> 
                        <tr>
                            <td className="hr2-b text-left">ความคิดเห็น</td>
                            <td className="hr2-b text-center"></td>
                        </tr> 
                        <tr>
                            <td className="hr2-b text-left">ผู้ตรวจ</td>
                            <td className="hr2-b text-center">{receiving.checking_by}</td>
                        </tr> 
                        <tr>
                            <td className="hr2-b text-left">ระยะเวลานัดรถเสร็จ</td>
                            <td className="hr2-b text-center">{this.getDate(receiving.appointment_date)}</td>
                        </tr> 
                        <tr>
                            <td className="text-left">ลูกค้า</td>
                            <td className="text-center"></td>
                        </tr> 
                        <tr>
                            <td className="text-left">โทร.</td>
                            <td className="text-center"></td>
                        </tr>               
                    </tbody>
                </table> 
              </div>
              <div style={{width:'50%', borderLeft:'1px solid #111'}}>
                <table className='table table-ndm-fixing' style={{marginTop:'0'}}>
                    <tbody>
                        <tr>
                            <td className="hr2-b text-left">หัวหน้างาน</td>
                            <td className="hr2-b text-center">{receiving.checking_by}</td>
                        </tr> 
                        <tr>
                            <td className="hr2-b text-left">ราคา</td>
                            <td className="hr2-b text-center"></td>
                        </tr> 
                        <tr>
                            <td className="hr2-b text-left">ช่างเคาะ</td>
                            <td className="hr2-b text-center"></td>
                        </tr> 
                        <tr>
                            <td className="hr2-b text-left">ช่างโป้ว</td>
                            <td className="hr2-b text-center"></td>
                        </tr> 
                        <tr>
                            <td className="hr2-b text-left">ช่างผสมสี</td>
                            <td className="hr2-b text-center"></td>
                        </tr> 
                        <tr>
                            <td className="hr2-b text-left">ช่างพ้นสี</td>
                            <td className="hr2-b text-center"></td>
                        </tr> 
                        <tr>
                            <td className="hr2-b text-left">ช่างขัดเงา</td>
                            <td className="hr2-b text-center"></td>
                        </tr> 
                        <tr>
                            <td className="hr2-b text-left">ช่างประกอบ</td>
                            <td className="hr2-b text-center"></td>
                        </tr> 
                        <tr>
                            <td className="text-left">เลขที่ใบสั่งซ่อม</td>
                            <td className="text-center">{this.props.workNo}</td>
                        </tr>               
                    </tbody>
                </table>
              </div>
            </div>    
          </div>   
          <br />   
          <center>
            <div style={{width:'40%'}}>
              <table className='table table-ndm-fixing' style={{marginTop:'0'}}>
                <tbody>
                    <tr>
                        <td style={{width:'60px'}}>ผู้สั่งซ่อม</td>
                        <td className="hr2-b text-center">{receiving.receiving_by}</td>
                    </tr>
                </tbody>
              </table>  
            </div>
          </center>  
        </div>
        <NotificationSystem ref="notificationSystem" />
      </div>  
    )
  }

  getDate(date='') {
    if (date!=''&&date!==undefined) { 
      let day = date.substring(0, 2)
      let month = date.substring(3, 5)
      let year = parseInt(date.substring(6, 10)) - 543
      let _date = year+'-'+month+'-'+day
      let d = new Date(_date);
      let weekday = new Array(7);
      weekday[0] = "วันอาทิตย์ ที่ ";
      weekday[1] = "วันจันทร์ ที่ ";
      weekday[2] = "วันอังคาร ที่ ";
      weekday[3] = "วันพุธ ที่ ";
      weekday[4] = "วันพฤหัสบดี ที่ ";
      weekday[5] = "วันศุกร์ ที่ ";
      weekday[6] = "วันเสาร์ ที่ ";
      let n = weekday[d.getDay()]
      return n + date
    }
    return ''  
  }

  render() {
    let {loading} = this.state
    return(
      <PrintPreview 
        loading={loading} 
        leftBarTitle={'ใบคุมรายการซ่อม '+this.props.workNo}
        onPrintDoc={this.onPrintDoc.bind(this)}
      >
        {this.renderComponentPage()}        
      </PrintPreview>
    )
  }

}  

PrintNDMFixingListOnCarDoc.defaultProps = {
  title: 'ใบ',  
  mode : '1'
}
export default PrintNDMFixingListOnCarDoc;


// WEBPACK FOOTER //
// ./src/view/print/ndm/PrintNDMFixingListOnCarDoc.js